import React, { Component } from 'react';
import { connect } from 'react-redux';

import { push, goBack } from 'connected-react-router';
import PageTemplate from '../../../components/PageTemplate/PageTemplate';
import './InputPhotoValidation.scss';
import EXIF from 'exif-js';

//icon
import thumbDown from '../../../assets/thump_down.png';
import thumbUp from '../../../assets/thump_up.png';

//text
import assistantText from '../../../assets/text/text.json';
import PrimaryButtonCard from '../../../components/PrimaryButtonCard/PrimaryButtonCard';
import { clearCurrentSearchImage, setSearchTerm, clearSearchTerm } from '../../../redux/actions/result.action';
import Search from '../../../services/Search.service';
import Translator from '../../../services/Translate.service';


/**
 * Home page component
 */
class InputPhotoValidation extends Component<{ navigateTo: any, searchImage: any, clearImage: any, setSearchTerm: any }, {}> {

    componentDidMount() {
        let image = this.props.searchImage;
        EXIF.getData(URL.createObjectURL(this.props.searchImage), function () {
            console.log("hello");
            console.log(EXIF.getTag(image, "Make"));
        })
    }

    renderBody() {
        try {
            return (
                <div className="preview-wrapper">
                    <img src={URL.createObjectURL(this.props.searchImage)} className="imagepreview" />
                    <div className="btn-container">
                        <PrimaryButtonCard text={assistantText.fotoMethodeBestätigung.noButton} icon={thumbDown} action={() => {
                    
                            this.props.clearImage();

                        }} />
                        <div style={{ width: 100 }}></div>
                        <PrimaryButtonCard text={assistantText.fotoMethodeBestätigung.yesButton} icon={thumbUp} action={() => {
                            Search.searchByFile(this.props.searchImage).then((result) => {
                                console.log(result);
                                Translator.translateToGerman(result.data.tags[0].name).then((result: any) => {
                                    this.props.setSearchTerm(result.data[0].translations[0].text);
                                    this.props.navigateTo('result')
                                });
                            }).catch(err => console.log(err));
                        }} />
                    </div>
                </div>)
        } catch (err) {
            return (<div></div>)
        }
    }

    /**
     * Main render method of component
     */
    render() {
        return (
            <div className="inputphotovalidation">
                <PageTemplate assistantLine1={assistantText.fotoMethodeBestätigung.Assistant.line1} assistantLine2={assistantText.fotoMethodeBestätigung.Assistant.line2} body={this.renderBody()} customBack={() => {
                    this.props.clearImage();
                }} />
            </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        searchImage: state.result.currentSearchImage
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        navigateTo(path: string) {
            dispatch(push(path));
        },
        clearImage() {
            dispatch(clearSearchTerm());
            dispatch(clearCurrentSearchImage());
            dispatch(goBack())
        },
        setSearchTerm(term: string) {
            dispatch(setSearchTerm(term))
        }
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InputPhotoValidation);